import { useTranslation } from 'react-i18next';

export const MypageUserDetail = ({
  email,
  familyName,
  firstName,
}: {
  email: string;
  familyName: string;
  firstName: string;
}) => {
  const { t } = useTranslation();

  return (
    <div className="mypage-detail">
      <div className="mypage-detail__row mypage-detail__row--email">
        <div className="mypage-detail__label">
          {t('myPage.userDetail.email')}
        </div>
        <div className="mypage-detail__value">{email}</div>
      </div>
      <div className="mypage-detail__row mypage-detail__row--name">
        <div className="mypage-detail__name-grid">
          <div className="mypage-detail__label mypage-detail__label--lastname">
            {t('myPage.userDetail.lastName')}
          </div>
          <div className="mypage-detail__label mypage-detail__label--firstname">
            {t('myPage.userDetail.firstName')}
          </div>
          <div className="mypage-detail__value mypage-detail__value--lastname">
            {familyName}
          </div>
          <div className="mypage-detail__value mypage-detail__value--firstname">
            {firstName}
          </div>
        </div>
      </div>
    </div>
  );
};
